import { Icon } from "@iconify/react";
import { Box, Button, Typography } from "@mui/material";

export const sogoAssessmentTableHeader = (navigate,fromDate,toDate,selectedDateCriteria) => [
  { field: "userName", headerName: "OGA Name", width: 300 },
  {
    field: "assessmentCount",
    headerName: "Total Assessment Taken",
    width: 220,
  },
  { field: "reportCount", headerName: "Total Report Generated", width: 200 },
  { field: "courseEnrollmentCount", headerName: "Course Enrollment Count", width: 200 },
  { field: "admissionCount", headerName: "Admissions Confirmed", width: 200 },
  { field: "unenrolledCount", headerName: "Admissions UnConfirmed", width: 200 },
  { field: "revenue", headerName: "Revenue", width: 200 },
  { field: "totalFees", headerName: "Sale Amount", width: 200 },
  { field: "arpu", headerName: "ARPU", width: 200 },
  { field: "acr", headerName: "ACR", width: 200 },
  { field: "tar", headerName: "TAR", width: 200 },
  { field: "sfr", headerName: "SFR", width: 200 },

  {
    field: "action",
    headerName: "Action",
    width: 150,
    renderCell: (params) => {
      return (
        <Button
          sx={{
            p:'7px',
            background:
              "linear-gradient(135deg, rgba(0, 139, 208, 0.79), rgba(160, 37, 194, 0.74))",
            color: "#fff",
            "&:hover": {
              background:
                "linear-gradient(135deg, rgb(0, 49, 208), rgb(171, 37, 194))",
            },
          }}
          onClick={() => navigate(`/my-workspace/oga-wise-report/?id=${params?.row?.userId}${
            fromDate ? `&fromDate=${fromDate}` : ""
          }${toDate ? `&toDate=${toDate}` : ""}&filterCriteria=${
        selectedDateCriteria?.id
      }`)}
          size="small"
          variant="outlined"
        >
          <Box sx={{display:'flex',alignItems:'center',justifyContent:'center',gap:1}}>
            <Typography variant="overline">OGA Report</Typography>
            <Icon icon="ep:d-arrow-right" width="15" height="15" />
          </Box>
        </Button>
      );
    },
  },
];
